import { IFile } from '../global/file';
import { IPaginationParams } from '../global/pagination';
import { ISortParams } from '../global/sort';

export interface IJourneyExecutionRequestParams extends IPaginationParams, ISortParams {
  journeyId?: number;
}
export interface IActionAttachmentFile {
  fileId: number;
  file: IFile;
}

export interface IJourneyExecution {
  id: number;
  journeyId: number;
  created: string;
  updated: string;
  type: string;
  attachmentFileIds: IActionAttachmentFile[]
}

export interface ISearchAction {
  id: number;
  journeyId: number;
  created: string;
  updated: string;
  type: string;
  attachmentFileIds: number[];
  attachmentFiles: ISearchActionAttachmentFile[];
}

export enum SearchActionType {
  DriverDelayed = 'DRIVER_DELAYED',
  TravellerNoShow = 'TRAVELLER_NO_SHOW',
  AdditionalProofTravellerNoShow = 'ADDITIONAL_PROOF_TRAVELLER_NO_SHOW',
}

export const SearchActionDisplayName = {
  [SearchActionType.DriverDelayed]: 'Driver late',
  [SearchActionType.TravellerNoShow]: 'Traveller no show',
  [SearchActionType.AdditionalProofTravellerNoShow]: 'Traveller no show, additional proof of no show',
};

export interface ISearchActionAttachmentFile {
  id: number;
  displayName: string;
  externalKey: string;
  contentType: string;
}

export interface ISearchActionsList {
  results: [ISearchAction] 
}
